import { Component, OnInit } from '@angular/core'
import { DrawerHelper } from '@delon/theme'

import { XiaoXingComponent } from '../../../layout/basic/widgets/xiaoxing.component'

@Component({
  selector: 'app-support-ai',
  template: `
    <div *ngIf="showHelpIcon" draggable class="helpIcon" (click)="openXiaoxingDialog()">
      <div class="close">
        <span nz-icon nzType="close-square" nzTheme="outline" (click)="hideHelpIcon()"></span>
      </div>
    </div>
  `,
  styles: [
    `
      :host ::ng-deep {
        .helpIcon {
          width: 150px;
          height: 150px;
          background-image: url('../../../../assets/images/help.png');
          background-repeat: no-repeat;
          background-size: 100% 100%;
          cursor: pointer;
          position: fixed;
          right: 10px;
          bottom: 10px;
          display: flex;
          justify-content: right;
          .close {
            display: none;
          }
        }

        .helpIcon:hover .close {
          display: block;
          span {
            font-size: 16px;
          }
        }
      }
    `,
  ],
})
export class SupportAiComponent implements OnInit {
  constructor(private modalHelper: DrawerHelper) {}

  ngOnInit(): void {}

  showHelpIcon = true
  openXiaoxingDialog(): void {
    this.modalHelper
      .create(
        'AIGC',
        XiaoXingComponent,
        {
          record: { operation: 'show', height: `${document.body.clientHeight - 83}px` },
        },
        {
          drawerOptions: {
            nzWidth: 800,
          },
          footer: false,
        },
      )
      .subscribe((res) => {
        if (res.successful) {
        }
      })
  }

  hideHelpIcon(): void {
    this.showHelpIcon = false
  }
}
